
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-shops",
      function () {
        return require("private-next-pages/my-shops.js");
      }
    ]);
  